import { EntityKeyConfig } from '../../../types/entities';

/**
 * Entity Keys for FITTING_CODES
 * 
 * Defines the key structure used throughout the application
 * for this entity type.
 */
export const keys: EntityKeyConfig = {
  single: 'fittingCode',
  plural: 'fittingCodes',
  state: 'fittingCodes'
};
